'use strict'

// import axios from "axios/index";
import axios from 'axios'
import { getQueryVariable } from '../util/const'

let bossToken, authorization;

// 如果url中带有这些信息，直接读取.在任何页面刷新都能读取
(bossToken = getQueryVariable('bossToken')) && setBossToken(bossToken);
(authorization = getQueryVariable('token')) && setAuthorization(authorization)

// 类似这种url：http://192.168.123.131:8080/#/roamcity?id=69&bossToken=c44629d92d9c30a0eca5e5e2e32e290b9&token=248432e4-8aaa-4aee-9936-e22b0efc3de7
function setBossToken (newValue) {
  bossToken = newValue
  // 这里设置的登录后所有接口都会带上这个header，如果值错误就算此接口不需要此header也会报错
  // 如果对接口区分是否要带header是一个比较大的工作量
  axios.defaults.headers.common['BossToken'] = bossToken
}

function getBossToken () {
  return bossToken
}

function clearBossToken () {
  delete axios.defaults.headers.common['BossToken']
}

function setAuthorization (newValue) {
  authorization = 'Bearer ' + newValue
  axios.defaults.headers.common['Authorization'] = authorization
}

function clearAuthorization () {
  delete axios.defaults.headers.common['Authorization']
}

function getAuthorization () {
  return authorization
}

function setHeader (obj) {
  for (let key in obj) {
    axios.defaults.headers.common[key] = obj[key]
  }
}

function getLang () {
  let lang = window.localStorage.getItem('lang')
  if (lang === 'tc') {
    return 'zh-TW'
  }
  if (lang === 'sc') {
    return 'zh-CN'
  }
  if (lang === 'en') {
    return 'en-US'
  }
}

export {
  setBossToken,
  getBossToken,
  clearBossToken,
  setAuthorization,
  getAuthorization,
  clearAuthorization,
  setHeader,
  getLang
}



// WEBPACK FOOTER //
// ./src/util/userInfo.js